package com.xtream.composeapp.theme

// ... your imports stay the same ...
import androidx.compose.material3.Typography
import androidx.compose.runtime.Composable
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.sp
import com.xtream.composeapp.platform.PlatformType
import com.xtream.composeapp.platform.currentPlatform
import com.xtream.sharedResources.resources.Res
import com.xtream.sharedResources.resources.metropolis_black
import com.xtream.sharedResources.resources.metropolis_bold
import com.xtream.sharedResources.resources.metropolis_extrabold
import com.xtream.sharedResources.resources.metropolis_extralight
import com.xtream.sharedResources.resources.metropolis_light
import com.xtream.sharedResources.resources.metropolis_medium
import com.xtream.sharedResources.resources.metropolis_regular
import com.xtream.sharedResources.resources.metropolis_regularitalic
import com.xtream.sharedResources.resources.metropolis_semibold
import com.xtream.sharedResources.resources.metropolis_thin
import com.xtream.sharedResources.resources.noto_naskh_arabic_regular
import org.jetbrains.compose.resources.Font
@Composable
fun getMetropolisFontFamily() = FontFamily(
    Font(Res.font.metropolis_regular, FontWeight.Normal),
    Font(Res.font.metropolis_thin, FontWeight.Thin),
    Font(Res.font.metropolis_extralight, FontWeight.ExtraLight),
    Font(Res.font.metropolis_light, FontWeight.Light),
    Font(Res.font.metropolis_medium, FontWeight.Medium),
    Font(Res.font.metropolis_semibold, FontWeight.SemiBold),
    Font(Res.font.metropolis_bold, FontWeight.Bold),
    Font(Res.font.metropolis_extrabold, FontWeight.ExtraBold),
    Font(Res.font.metropolis_black, FontWeight.Black),
    Font(Res.font.metropolis_regularitalic, FontWeight.Normal, FontStyle.Italic)
)
// 1. Change this to a Composable function
@Composable
fun getNotoFontFamily() = FontFamily(
    Font(Res.font.noto_naskh_arabic_regular  , FontWeight.Normal),
    Font(Res.font.noto_naskh_arabic_regular  , FontWeight.Thin),
    Font(Res.font.noto_naskh_arabic_regular  , FontWeight.ExtraLight),
    Font(Res.font.noto_naskh_arabic_regular  , FontWeight.Light),
    Font(Res.font.noto_naskh_arabic_regular  , FontWeight.Medium),
    Font(Res.font.noto_naskh_arabic_regular  , FontWeight.SemiBold),
    Font(Res.font.noto_naskh_arabic_regular  , FontWeight.Bold),
    Font(Res.font.noto_naskh_arabic_regular  , FontWeight.ExtraBold),
    Font(Res.font.noto_naskh_arabic_regular  , FontWeight.Black),
    Font(Res.font.noto_naskh_arabic_regular  , FontWeight.Normal, FontStyle.Italic)
)

// 2. Wrap Typography in a Composable function
@Composable
fun getTypography(): Typography {
    val fontFamily = if (currentPlatform==PlatformType.WEB) getNotoFontFamily() else getMetropolisFontFamily()
    return Typography(
        bodySmall = TextStyle(
            fontFamily = fontFamily,
            fontWeight = FontWeight.Light,
            fontSize = 10.sp,
            letterSpacing = 1.sp,
            lineHeight = 16.sp,
        ),
        bodyMedium = TextStyle(
            fontFamily = fontFamily,
            fontWeight = FontWeight.Normal,
            fontSize = 12.sp,
            letterSpacing = 1.3.sp,
            lineHeight = 16.sp,
        ),
        bodyLarge = TextStyle(
            fontFamily = fontFamily,
            fontWeight = FontWeight.Bold,
            letterSpacing = 1.3.sp
        ),
        titleMedium = TextStyle(
            fontFamily = fontFamily,
            fontWeight = FontWeight.Bold,
            fontSize = 14.sp,
            letterSpacing = 1.5.sp,
            lineHeight = 16.sp,
        ),
        titleLarge = TextStyle(
            fontFamily = fontFamily,
            fontWeight = FontWeight.Bold,
            fontSize = 18.sp,
            letterSpacing = 1.5.sp,
            lineHeight = 16.sp,
        ),
        headlineMedium = TextStyle(
            fontFamily = fontFamily,
            fontWeight = FontWeight.SemiBold,
            fontSize = 24.sp
        )
    )
}
